import { render, staticRenderFns } from "./ResidentGroupRegister.vue?vue&type=template&id=5b08e59a&scoped=true&lang=pug"
import script from "./ResidentGroupRegister.vue?vue&type=script&lang=ts"
export * from "./ResidentGroupRegister.vue?vue&type=script&lang=ts"
import style0 from "./ResidentGroupRegister.vue?vue&type=style&index=0&id=5b08e59a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08e59a",
  null
  
)

export default component.exports